import { render, staticRenderFns } from "./CQ.vue?vue&type=template&id=52defc38&scoped=true&"
import script from "./CQ.vue?vue&type=script&lang=js&"
export * from "./CQ.vue?vue&type=script&lang=js&"
import style0 from "./CQ.vue?vue&type=style&index=0&id=52defc38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52defc38",
  null
  
)

export default component.exports